import React from 'react'
import { Header2, Text } from '../styles/Components'
import styled from '@emotion/styled'
import { mq } from '../helpers'

export const HowItWorksWrapper = styled.section`
  padding: 68px 88px;
  max-width: 1600px;
  width: 100%;

  ${mq('max', '768px')} {
    padding: 50px 16px;
  }

  .how-content {

    .items-container {
      border-left: 1px solid black;
      margin-top: 54px;
      padding-left: 100px;
      gap: 50px;
      display: flex;
      justify-content: space-between;

      ${mq('max', '768px')} {
        flex-direction: column;
        border: none;
        padding-left: 0;
      }

      .item {
        max-width: 350px;
        display: flex;
        flex-direction: column;
        gap: 12px;

        ${mq('max', '768px')} {
          max-width: 100%;
        }
      }
    }
  }
`


const HowItWorks = ({ data, title = 'How it works'}) => {
  return (
    <HowItWorksWrapper>
      <div className='how-content'>
        <Header2 align='center'>{title}</Header2>
        <div className='items-container'>
          { Object.keys(data).map((item, i) => (
            <div className='item' key={i}>
              <Text weight={700} fontSize={22}>
                {item}
              </Text>
              <Text weight={400} fontSize={22}>
                {data[item]}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </HowItWorksWrapper>
  )
}

export default HowItWorks
